import { useState } from "react";

export type RfxViewMode = "grid" | "list";

/**
 * Card/list toggle state for RFx list pages (T&Q, Approvals, Panel).
 *
 * Restores the legacy `RFQ.js` behaviour (deleted by PRO-637 Task 008):
 * plain component-level `useState`, defaulting to `"grid"` (cards), with NO
 * persistence across mounts/reloads — the legacy screen never wrote the
 * preference to localStorage or redux, it just lived in `RFQ`'s own state
 * for the lifetime of the mounted page. Kept as a shared hook so all four
 * `renderList` consumers (TendersQuotesList, BidderTendersQuotesTab,
 * PanelList, ApprovalsList) use the exact same default + toggle contract.
 */
export const useRfxViewMode = (initial: RfxViewMode = "grid") => {
	const [view, setView] = useState<RfxViewMode>(initial);
	return { view, setView };
};
